export default __webpack_public_path__ + "locales/el-GR/Ldap.json?hash=56679400c13a35b6f5affcfee125fbf4";